<template>
  <div class="tableCompent">
    <el-button
      type="primary"
      icon="el-icon-plus"
      class="creatButton"
      v-if="!editCompany"
      @click="openDialog()"
      >{{ $t('personnel.button.add') }}</el-button
    >
    <el-button
      type="primary"
      icon="el-icon-delete"
      class="deteButton"
      v-if="!editCompany"
      @click="handleDelete('xTable')"
      >{{ $t('personnel.button.deletChange') }}</el-button
    >
    <vxe-table
      border
      :auto-resize="true"
      show-overflow
      size="mini"
      ref="xTable"
      :data="personCompanyDos"
      :edit-rules="validRules"
      :valid-config="{ autoPos: true, message: 'inline' }"
      :edit-config="{ trigger: 'click', mode: 'row', showStatus: true }"
    >
      <vxe-table-column type="checkbox" width="60"></vxe-table-column>
      <vxe-table-column
        type="index"
        width="200"
        :title="$t('personnel.table.index')"
      ></vxe-table-column>
      <vxe-table-column
        field="companyDepartment"
        :title="$t('personnel.table.companyDepartment')"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="{ row }">
          <el-cascader
            v-model="row.companyDepartment"
            :options="companyDepartmentList"
            :disabled="editCompany"
            @change="handleChange(row)"
            filterable
            clearable
          ></el-cascader>
        </template>
        <template v-slot="{ row }">
          <a style="color: #00b400" @click.stop="toOrganization(1, row)" href="#">{{
            getCascaderLabel(1, row.companyDepartment, companyDepartmentList)
          }}</a>

          <a
            style="margin-left: 5px; color: #00b400"
            @click.stop="toOrganization(2, row)"
            href="#"
            >{{ getCascaderLabel(2, row.companyDepartment, companyDepartmentList) }}</a
          >
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="sequenceOrder"
        :title="$t('personnel.routerTitle.waitForLine')"
        width="300"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <el-input
            :disabled="editCompany"
            v-model="scope.row.sequenceOrder"
            @input="$refs.xTable.updateStatus(scope)"
            clearable
          ></el-input>
        </template>
      </vxe-table-column>
    </vxe-table>
    <depart-dialog @confirm="insertEvent" ref="departDialog"></depart-dialog>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import API from '@/api/masterData/personnel';
  import departDialog from './departDialog';
  import XEUtils from 'xe-utils';
  export default {
    name: 'tableCompent',
    props: {
      editCompany: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      departDialog,
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
      user() {
        return this.userInfo.userInfo;
      },
    },
    data() {
      //序列排序
      var checkNumber = (rule, value, callback) => {
        let reg = /^[0-9]*$/;
        if (!reg.test(value)) {
          callback(new Error(this.$t('personnel.routerTitle.writeNumber')));
        } else {
          if (value > 9999 || value < 0) {
            callback(new Error(this.$t('personnel.routerTitle.writeNumber')));
          } else {
            callback();
          }
        }
      };
      return {
        flag: true,
        personCompanyDos: [],
        personCompanyList: [],
        personDepartmentList: [],
        companyDepartmentList: [],
        validRules: {
          companyDepartment: [
            {
              required: true,
              message: `${this.$t('personnel.table.companyDepartmentRules')}`,
            },
          ],
          sequenceOrder: [
            { required: true, message: `${this.$t('personnel.table.sortNo')}` },
            { validator: checkNumber },
          ],
        },
      };
    },
    mounted() {
      this.getCompany();
    },
    methods: {
      getCascaderLabel(val, value, list) {
        let values = value || [];
        let labels = [];
        let matchCascaderData = function (index, list) {
          let val = values[index];
          if (list && values.length > index) {
            list.forEach((item) => {
              if (item.value === val) {
                labels.push(item.label);
                matchCascaderData(++index, item.children);
              }
            });
          }
        };
        matchCascaderData(0, list);
        if (val == 1) {
          return labels[0];
        } else {
          return labels[1];
        }
      },
      getCascaderLabel2(value, list) {
        let values = value || [];
        let labels = [];
        let matchCascaderData = function (index, list) {
          let val = values[index];
          if (list && values.length > index) {
            list.forEach((item) => {
              if (item.value === val) {
                labels.push(item.label);
                matchCascaderData(++index, item.children);
              }
            });
          }
        };
        matchCascaderData(0, list);
        return labels[0];
      },
      //表格查重
      deWeight() {
        let flag = false;
        let arr = this.personCompanyDos;
        const arr1 = arr.reduce(
          (all, next) =>
            all.some(
              (atom) =>
                atom['personCompanyCode'] == next['personCompanyCode'] &&
                atom['personDepartmentCode'] == next['personDepartmentCode']
            )
              ? all
              : [...all, next],
          []
        );
        if (arr.length != arr1.length) {
          flag = true;
        }
        return flag;
      },
      //表格下拉框转换值方法
      getSelectLabel(value, list, valueProp = 'value', labelField = 'label') {
        let item = XEUtils.find(list, (item) => item[valueProp] === value);
        return item ? item[labelField] : null;
      },
      toOrganization(index, value) {
        let paths = {};
        if (index == 1) {
          let path = {
            path: '/masterData/company',
            name: 'company',
            meta: {
              keepAlive: true,
              title: this.$t('personnel.table.companyMaintain'),
            },
            params: {
              name: value.personCompanyName,
            },
          };
          paths = path;
        } else {
          let path = {
            path: '/masterData/department',
            name: 'department',
            meta: {
              keepAlive: true,
              title: this.$t('personnel.table.departmentMaintain'),
            },
            params: {
              name: value.personDepartmentName,
            },
          };
          paths = path;
        }
        this.$store.dispatch('tagsView/addTabView', paths).then(() => {
          this.$nextTick(() => {
            this.$router.push(paths);
          });
        });
      },
      //校验
      fullValidEvent() {
        this.flag = true;
        let formList = ['xTable'];
        let resultArr = [];
        let _self = this;
        function validates(formName) {
          let result = new Promise((resolve, reject) => {
            _self.$refs[formName].validate((valid) => {
              valid ? resolve() : reject();
            });
          });
          resultArr.push(result);
        }
        formList.forEach((item) => {
          validates(item); // 循环校验
        });
        this.personCompanyDos = this.$refs.xTable.getTableData().fullData;
        if (this.personCompanyDos.length <= 0) {
          this.flag = false;
        }
        let childList = {
          personCompanyDos: this.personCompanyDos,
          flag: this.flag,
        };
        return Promise.all(resultArr)
          .then(() => {
            if (!this.flag) {
              this.$message({
                showClose: true,
                message: this.$t('personnel.table.tableTitle'),
                type: 'error',
              });
            } else {
              return childList;
            }
          })
          .catch(() => {});
      },
      handleChange(value) {
        this.personCompanyDos.forEach((item) => {
          if (item._XID == value._XID) {
            item.personCompanyCode = value.companyDepartment[0];
            item.personDepartmentCode = value.companyDepartment[1];
            this.companyDepartmentList.forEach((res) => {
              if (res.value == item.personCompanyCode) {
                item.personCompanyName = res.label;
                res.children.forEach((val) => {
                  if (val.value == item.personDepartmentCode) {
                    item.personDepartmentName = val.label;
                  }
                });
              }
            });
          }
        });
      },
      openDialog() {
        let chkVals = this.personCompanyDos.map((item) => {
          return item.personDepartmentCode;
        });
        let data = XEUtils.clone(this.companyDepartmentList, true);
        chkVals.map((item) => {
          data.map((i) => {
            i.children.map((j) => {
              if (j.value == item) {
                j.disabled = true;
              }
            });
          });
        });
        this.$refs.departDialog.openDialog(chkVals, data);
      },
      insertEvent(chkNodes) {
        let max = 0;
        this.personCompanyDos.map((item) => {
          if (max < item.sequenceOrder) {
            max = item.sequenceOrder;
          }
        });
        chkNodes.map((item) => {
          max++;
          this.personCompanyDos.push({
            companyDepartment: [item.companyCode, item.value],
            personCompanyCode: item.companyCode,
            personCompanyName: item.companyName,
            personDepartmentCode: item.value,
            personDepartmentName: item.label,
            sequenceOrder: max,
          });
        });
      },
      //增加
      // insertEvent(row) {
      //   let xTable = this.$refs.xTable;
      //   let record = {};
      //   xTable.insertAt(record, row).then(({ row }) => {
      //     xTable.setActiveRow(row);
      //   });
      //   this.personCompanyDos = this.$refs.xTable.getTableData().fullData;
      // },
      roleChangeEvent(row, val) {
        if (val == 1) {
          row.personDepartmentList = [];
          // this.$refs.xTable.clearActived();//实时变更过表格数据
          let personCompanyName = '';
          this.personCompanyList.forEach((item) => {
            if (item.value == row.personCompanyCode) {
              personCompanyName = item.label;
            }
          });
          this.$axios
            .post(API.LISTDATA_SERECHDEPARTMENT + `/${row.personCompanyCode}`)
            .then((res) => {
              row.personDepartmentList = res.data.data;

              this.personCompanyDos.forEach((item) => {
                if (item._XID == row._XID) {
                  item.personCompanyName = personCompanyName;
                  item.personDepartmentList = row.personDepartmentList;
                  item.personDepartmentName = '';
                  item.personDepartmentCode = '';
                }
              });
            });
        } else {
          let personDepartmentName = '';
          this.personDepartmentList.forEach((item) => {
            if (item.value == row.personDepartmentCode) {
              personDepartmentName = item.label;
            }
          });
          this.personCompanyDos.forEach((item) => {
            if (item._XID == row._XID) {
              item.personDepartmentName = personDepartmentName;
            }
          });
        }
      },
      // 删除
      handleDelete(tableTpye) {
        const selectedList = this.$refs[tableTpye].getSelectRecords(); // 或许选中数据
        if (selectedList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('personnel.table.chockedLows'),
            type: 'error',
          });
          return;
        }
        this.$confirmAction()
          .then(() => {
            this.$refs[tableTpye].removeSelecteds();
            this.personCompanyDos = this.$refs.xTable.getTableData().fullData;
            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('personnel.table.deletSuccess'),
            });
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('personnel.table.deletFalse'),
            });
          });
      },
      //获取公司
      async getCompany() {
        let parames = {
          belongTenantCode: this.user.tenantCode,
          currentStatus: 0,
        };
        const selectStatus = await this.$axios.post(API.LISTDATA_SERECHCOMPANYTREE, parames);
        if (selectStatus.data.code == 0) {
          this.companyDepartmentList = selectStatus.data.data;
          this.companyDepartmentList.map((item) => {
            item.children.map((i) => {
              (i.companyCode = item.value), (i.companyName = item.label);
            });
          });
        }
      },
    },
  };
</script>
<style lang="scss" scoped>
  .tableCompent .creatButton {
    background-color: rgb(98, 153, 254) !important;
    border: 1px solid rgb(98, 153, 254) !important;
    min-width: 80px;
    border-radius: 2px !important;
    margin-top: 10px 0;
  }
  .tableCompent .deteButton {
    background-color: #fe8783 !important;
    border: 1px solid #fe8783 !important;
    min-width: 80px;
    border-radius: 2px !important;
    margin: 10px 10px;
  }
  .tableCompent .el-cascader--small {
    font-size: 13px;
    line-height: 32px;
    width: 100%;
  }
</style>
